import { RequestExcepcionesPeriodoInactividad, ResponseSolicitudPeriodoInactividad } from "interfaces/periodosinactividad/periodosInactividadInterface";
import tribunalAPI from "../../api/tribunalAPi";

const getPeriodoInactividadService = async () => {
  let url = `/periodosinactividad/obtener-periodo`;
  return await tribunalAPI.get<ResponseSolicitudPeriodoInactividad>(url);
};

const getExcepcionesInactividad = async (
  params: RequestExcepcionesPeriodoInactividad
) => {
  let url = "/periodosinactividad/obtener-excepciones";
  return await tribunalAPI.get<any>(url, { params });
};

export { getPeriodoInactividadService, getExcepcionesInactividad };
